var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"electionBanner",attrs:{"to":"/election-probability"}},[_c('span',{staticClass:"liveDot"}),_c('span',{staticClass:"bannerLabel"},[_vm._v("LATEST: There is a "),_c('strong',[_vm._v(_vm._s(_vm.totalPct))]),_vm._v("% probability of an election happening soon ")]),_c('span',{staticClass:"bannerArrow"},[_vm._v("→")])])
}
var staticRenderFns = []

export { render, staticRenderFns }